const getActiveUser = state => state.activeUser;

const hasToken = state => state.activeUser.apiKey !== undefined;

export default {
  getActiveUser,
  hasToken
};
